import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CustomerUser } from "@src/app/models/customeruser";
import { Customer } from "./model/customer";
import { CustomerControlService } from "./service/customer-control.service";
import {
  trigger,
  style,
  animate,
  transition,
} from "@angular/animations";
import { AuthorizationService } from "@src/app/helpers/authorization.service";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { Router } from "@angular/router";
import { UieventhubService } from "@src/app/helpers/uieventhub/uieventhub.service";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-customer-control",
  templateUrl: "./customer-control.component.html",
  styleUrls: ["./customer-control.component.css"],
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class CustomerControlComponent implements OnInit {
  @Output() customerList: Customer[];
  filteredCustomerList: Customer[];
  @Output() modalCustomer: Customer;
  @Input() createCustomer: Customer;
  @Output() readonly: boolean = true;
  @Output() editstate: string = "Make changes";
  @Output() errorMessage: string;
  @Output() createUser: boolean;
  @Output() userList: boolean;
  @Output() userToAdd: CustomerUser;
  deletebutton: boolean;
  spinner: boolean;
  @ViewChild("customercreateModal", { static: true })
  customercreateModal: ElementRef;
  @ViewChild("closeeditmodal", { static: true }) closeeditmodal: ElementRef;
  hubspotintegration: boolean = false;
  filterTxt: string;

  modules = {
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      // onSelect: (item, insertItem) => {
      //   const editor = this.editor.quillEditor
      //   insertItem(item)
      //   // necessary because quill-mention triggers changes as 'api' instead of 'user'
      //   editor.insertText(editor.getLength() - 1, '', 'user')
      // },
    },
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
    ],
  };

  constructor(
    private custsrv: CustomerControlService,
    private auth: AuthorizationService,
    private router: Router,
    private uievent: UieventhubService,
    private datastore: DatastoreService,
  ) {}
  canCreateCustomer() {
    return this.auth.isAuthorized(
      "customercreate",
      SessionHelper.getChoosenOrg()
    );
  }
  ngOnInit() {
   //console.log("Customer control init");
    this.uievent.removeLoader("personname");

    //this.uievent.addLoader("customercontrol");
    this.hubspotintegration = SessionHelper.getHubspot() ? true : false;
    this.deletebutton = false;
    this.createUser = false;
    this.userList = true;
    this.customerList = [];
    this.filteredCustomerList = [];
    this.createCustomer = new Customer();
    this.modalCustomer = new Customer();
    //this.customerList = this.datastore.customers.getValue();
    
    this.datastore.customers.pipe(untilDestroyed(this)).subscribe((custlist) => {
      Promise.resolve().then(() => {
        const safeList = Array.isArray(custlist) ? [...custlist] : [];
        this.customerList = safeList;
        this.sortCustomers();
        this.filteredCustomerList = [...this.customerList];

        if (this.hubspotintegration) {
          this.customerList.forEach((cust) => {
            //get deals for customer
            this.custsrv
              .getDeals(cust.customerId.split("_")[0], new Date().toISOString())
              .pipe(untilDestroyed(this)).subscribe((deals) => {
                cust.numberofdeals = deals.length;
                this.uievent.removeLoader("customerlist");
              });
          });
        } else {
          this.uievent.removeLoader("customerlist");
        }
      });
      //this.uievent.removeLoader("customercontrol");
    });


    // this.custsrv
    //   .getCustomers(new Date().toISOString())
    //   .pipe(untilDestroyed(this)).subscribe((custlist) => {
    //     //console.log(custlist);
    //     this.customerList = custlist;
    //     if (this.hubspotintegration) {
    //       this.customerList.forEach((cust) => {
    //         //get deals for customer
    //         this.custsrv
    //           .getDeals(cust.customerId.split("_")[0], new Date().toISOString())
    //           .pipe(untilDestroyed(this)).subscribe((deals) => {
    //             cust.numberofdeals = deals.length;
    //           });
    //       });
    //     }
    //     this.sortCustomers();
    //     this.uievent.removeLoader("customercontrol");
    //   });
  }
  setFilteredList(list: Customer[]) {
    Promise.resolve().then(() => {
      this.filteredCustomerList = Array.isArray(list) ? [...list] : [];
    });
  }

  customerClicked(customer: Customer) {
    this.modalCustomer = customer;
    this.readonly = true;
    this.editstate = "Make changes";
  }
  onRegister() {
    //console.log(JSON.stringify(this.createCustomer));
    this.custsrv.createCustomer(this.createCustomer).pipe(untilDestroyed(this)).subscribe(
      (custId) => {
        this.createCustomer.customerId = custId;
        this.customerList.push(this.createCustomer);
        this.customercreateModal.nativeElement.click();
        this.router.navigate(["/customer/" + custId.substring(0, 36)]);
      },
      (error) => {
        this.errorMessage = error.error;
      }
    );
  }
  sortCustomers() {
    this.customerList = this.customerList.sort((a, b) => {
      if (a.title.toLowerCase() < b.title.toLowerCase()) {
        return -1;
      }
      if (a.title.toLowerCase() > b.title.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }
  onChange() {
    // Only do stuff if the form is enabled
    if (this.readonly == true) {
      this.readonly = false;
      this.editstate = "Save";
      this.deletebutton = true;
    } else {
      this.custsrv.updateCustomer(this.modalCustomer).pipe(untilDestroyed(this)).subscribe((custId) => {
        this.modalCustomer.customerId = custId;
        this.readonly = true;
        this.editstate = "Make changes";
        this.deletebutton = false;
      });
    }
  }
  onDelete() {
    this.custsrv.deleteCustomer(this.modalCustomer).pipe(untilDestroyed(this)).subscribe((done) => {
      let index = this.customerList.indexOf(this.modalCustomer);
      this.customerList.splice(index, 1);

      this.closeeditmodal.nativeElement.click();
    });
  }

  onClick() {
    this.createUser = !this.createUser;
    this.userList = !this.userList;
    //console.log (this.userList);
    //console.log (this.createUser);
  }
  addCustomerUser(user: CustomerUser) {
    this.userToAdd = user;
    this.createUser = false;
    this.userList = true;
  }

  cancelCreateuser() {
    this.createUser = false;
    this.userList = true;
  }
}
